export default __webpack_public_path__ + "static/media/discord_server_icon.b36af1a2.png";